// extracted by mini-css-extract-plugin
export default {"menuBlock":"XF-z","title":"YF-z","nav":"ZF-z","flexCell":"_F-z","facetLink":"aG-z"};